import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tmgd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(url, fallbackName) {
  const res = await api.get(url, { responseType: "blob" });
  const disp = res.headers["content-disposition"] || "";
  let name = fallbackName || "dosya";
  const m = /filename\*=UTF-8''([^;]+)/.exec(disp);
  if (m) name = decodeURIComponent(m[1]);
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

export async function previewFile(url) {
  const res = await api.get(url, { responseType: "blob" });
  let blob = res.data;
  if (!(blob instanceof Blob)) blob = new Blob([blob], { type: "application/pdf" });
  if (!blob.type || blob.type === "application/octet-stream") blob = new Blob([blob], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  const win = window.open(blobUrl, "_blank", "noopener");
  if (!win) toast.error("Tarayıcı yeni sekmeyi engelledi. Lütfen açılır pencere iznini verin veya İndir'i kullanın.");
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}

export default api;
